module.exports = __webpack_public_path__ + "img/zhucanfuwu_image_ylfw_zlfw.d8ac6682.png";